import { AfterViewChecked, AfterViewInit, Component, effect, inject, input, ViewChild } from '@angular/core';
import { LinksSectionComponent } from '@shared/components/links-section/links-section.component';
import { SideNavigationComponent } from '@shared/components/side-navigation/side-navigation.component';
import { IDetails_Response } from '@shared/constants/models.const';
import { BreadcrumbsComponent } from '@shared/components/breadcrumbs/breadcrumbs.component';
import { ThreeColumnTemplateComponent } from '@templates/three-column-template/three-column-template.component';
import {
  PublicationCardComponent,
  PublicationsType,
} from '../home/components/latest-publications-section/components/publication-card/publication-card.component';
import { CkViewerComponent } from '@shared/components/ck-viewer/ck-viewer.component';
import { TranslateModule } from '@ngx-translate/core';
import { BUTTON_TYPES } from '@shared/components/button/button-types.enum';
import { E_CONTENT_TYPE } from '@shared/constants/enums.const';
import { TocComponent } from '@shared/components/toc/toc.component';
import { HelperService } from '../../services/helper.service';
import { HorizontalDividerComponent } from '@shared/components/horizontal-divider/horizontal-divider.component';
import { SelectCategoryComponent } from '../home/components/select-category/select-category.component';
import { SectionTemplateComponent } from '@templates/section-template/section-template.component';
import { SeeAllComponent } from '@shared/components/see-all/see-all.component';
import { DefaultPortletsComponent } from '@shared/components/default-portlets/default-portlets.component';
import { Router } from '@angular/router';
import { CollectionsComponent } from '@shared/components/collections/collections.component';

@Component({
  selector: 'app-publication-list',
  imports: [
    LinksSectionComponent,
    SideNavigationComponent,
    BreadcrumbsComponent,
    ThreeColumnTemplateComponent,
    PublicationCardComponent,
    CkViewerComponent,
    TranslateModule,
    TocComponent,
    HorizontalDividerComponent,
    SelectCategoryComponent,
    SectionTemplateComponent,
    SeeAllComponent,
    DefaultPortletsComponent,
    CollectionsComponent,
  ],
  templateUrl: './publication-list.component.html',
  styleUrl: './publication-list.component.scss',
})
export class PublicationListComponent implements AfterViewInit, AfterViewChecked {
  pageData = input.required<IDetails_Response | any>();
  @ViewChild(SelectCategoryComponent) SelectCategory!: SelectCategoryComponent;

  protected readonly PublicationsType = PublicationsType;
  protected readonly ButtonTypes = BUTTON_TYPES;
  protected readonly E_CONTENT_TYPE = E_CONTENT_TYPE;
  readonly HELPER: HelperService = inject(HelperService);
  // readonly cd: ChangeDetectorRef = inject(ChangeDetectorRef);
  readonly router: Router = inject(Router);

  constructor() {
    effect(() => {
      if (this.pageData()) this.HELPER.saveForLastUrl(this.pageData().title);
    });
  }

  isSeeAllDisabled = false;

  get isStickyVisible() {
    return this.HELPER.selectCategoryStickyState;
  }


  get hasRelatedItems(): boolean {
    return !!this.pageData()?.items?.items?.length;
  }

  ngAfterViewInit() {
    // this.HELPER.selectCategoryStickyState = false;
    this.HELPER.selectCategoryHandle(this.SelectCategory);
  }

  ngAfterViewChecked() {
    this.HELPER.saveForLastUrl(this.pageData().title);
    const isItSame = this.HELPER.getLastTitle() === this.pageData().title;

    this.isSeeAllDisabled = isItSame === this.isSeeAllDisabled;

  }

  seeAll($event: MouseEvent) {
    $event.preventDefault();
    $event.stopPropagation();
    this.HELPER.saveForLastUrl(this.pageData().title);

    setTimeout(() => {
      const isItSame = this.HELPER.getLastTitle() === this.pageData().title;
      if (isItSame) {
        this.isSeeAllDisabled = false;
        this.router.navigate([`/${this.HELPER.frLoc}/related-publications`]);
      }
    }, 50);

  }
}
